import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["cols", "lg"]
const _hoisted_2 = { class: "accent--text mb-2 font-weight-medium cursor-pointer d-inline-block text-body-1" }
const _hoisted_3 = ["cols", "lg"]
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = {
  class: "flex flex-row gap-2",
  style: { position: 'relative' }
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.8581 6.54565C13.8581 6.54565 13.4098 12.1059 13.1498 14.448C13.0259 15.5666 12.3349 16.2221 11.2031 16.2428C9.04917 16.2816 6.89278 16.2841 4.7397 16.2387C3.65077 16.2164 2.97133 15.5526 2.84997 14.4538C2.58826 12.091 2.14246 6.54565 2.14246 6.54565",
    stroke: "#FFFFFF",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 3.88034H1",
    stroke: "#FFFFFF",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.3025 3.88041C11.6545 3.88041 11.0964 3.42222 10.9692 2.78736L10.7686 1.78347C10.6448 1.32032 10.2254 1 9.7474 1H6.25277C5.77476 1 5.35537 1.32032 5.23154 1.78347L5.03093 2.78736C4.90379 3.42222 4.3457 3.88041 3.69763 3.88041",
    stroke: "#FFFFFF",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "20",
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.96 9.41986C20.8233 8.32141 20.326 7.29927 19.546 6.51386C18.766 5.72844 17.7474 5.22406 16.65 5.07977C16.1768 3.75468 15.2529 2.63824 14.0399 1.92523C12.8269 1.21223 11.4019 0.948014 10.0139 1.17914C8.62597 1.41026 7.36341 2.12202 6.4469 3.18964C5.53039 4.25726 5.01826 5.61302 5 7.01996C3.93913 7.01996 2.92172 7.4412 2.17157 8.19135C1.42142 8.94149 1 9.95909 1 11.02C1 12.0808 1.42142 13.0982 2.17157 13.8483C2.92172 14.5985 3.93913 15.02 5 15.02H11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.7793 19V11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.5801 14.2L17.7801 11L20.98 14.2",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row", _ctx.margin])
  }, [
    (!!_ctx.$attrs.label)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex flec-col",
          cols: _ctx.MobileLabelCol,
          lg: _ctx.LabelCol
        }, [
          _createElementVNode("div", {
            class: "text-left mt-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refs.fileInputRef.click()))
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$attrs.label), 1)
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex flex-col flex-grow-1",
      cols: _ctx.MobileFieldCol,
      lg: !!_ctx.$attrs.label ? _ctx.FieldCol : 12
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.ImageLink)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["button-upload-logo relative", { 'button-upload-cover': _ctx.fieldName != 'Logo' }])
              }, [
                _createElementVNode("img", {
                  class: "rounded-md w-full h-full object-cover",
                  src: _ctx.ImageLink
                }, null, 8, _hoisted_6),
                (_ctx.ImageLink)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "bg-black bg-opacity-40 p-1.5 rounded-full absolute top-2 right-2",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteImage && _ctx.deleteImage(...args)))
                    }, _hoisted_8))
                  : _createCommentVNode("", true)
              ], 2))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["button-upload-logo", { 'button-upload-cover': _ctx.fieldName != 'Logo' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs[`fileInputRef`].click()))
              }, _hoisted_10, 2)),
          _createElementVNode("input", {
            type: "file",
            id: "fileUpload",
            class: "d-none",
            ref: "fileInputRef",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onUpload && _ctx.onUpload(...args))),
            multiple: false,
            accept: "image/*",
            hidden: ""
          }, null, 544)
        ])
      ])
    ], 8, _hoisted_3)
  ], 2))
}